export default __webpack_public_path__ + "static/media/sportsbra-small-front.dc569868.jpg";